<template>
  <v-dialog :value="dialog" max-width="1300" @input="closeDialog">
    <v-card>
      <v-card-title>โคลนข้อมูลจากที่อื่น</v-card-title>
      <v-card-text class="pt-6">
        <FormSelectAssuranceInput
          @onSubmit="handleSubmit"
          :disabled-assurance-level="true"
          :assurance-level="assuranceLevel"
        />
        <div class="mb-6">
          <v-switch
            v-model="formData.copy_evidence_file"
            label="โคลนรายการหลักฐานด้วย"
            color="primary"
            hide-details
          ></v-switch>
        </div>
        <template v-if="showConfirmMessage">
          <p>
            <b>คุณต้องการโคลนข้อมูล</b>
          </p>
          <v-row>
            <v-col cols="12" md="6">
              <ul class="list-style-none">
                <li>
                  <v-icon class="mr-3" color="primary">fa-file-arrow-up</v-icon>
                  <b>จาก:</b>
                </li>
                <li>{{ confirmMessage.from.assuranceLevel }}</li>
                <li>ปี {{ confirmMessage.from.year }}</li>
                <li v-if="vwTopicQuery.assuranceLevelId === 2">
                  คณะ {{ confirmMessage.from.faculty }}
                </li>
                <li v-if="vwTopicQuery.assuranceLevelId === 3">
                  สาขา {{ confirmMessage.from.major }}
                </li>
              </ul>
            </v-col>
            <v-col cols="12" md="6">
              <ul class="list-style-none">
                <li>
                  <v-icon class="mr-3" color="primary"
                    >fa-file-arrow-down</v-icon
                  >
                  <b>มา:</b>
                </li>
                <li>{{ confirmMessage.to.assuranceLevel }}</li>
                <li>ปี {{ confirmMessage.to.year }}</li>
                <li v-if="vwTopicQuery.assuranceLevelId === 2">
                  คณะ {{ confirmMessage.to.faculty }}
                </li>
                <li v-if="vwTopicQuery.assuranceLevelId === 3">
                  สาขา {{ confirmMessage.to.major }}
                </li>
              </ul>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeDialog"> ยกเลิก </v-btn>
        <v-btn
          color="primary"
          :disabled="disabledConfirmBtn"
          @click="onConfirmClone"
          :loading="cloneAssuranceFromLoading"
        >
          ยืนยัน
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex"
import { getAssurances } from "@/store/helper"
import FormSelectAssuranceInput from "@/components/form/FormSelectAssuranceInput"
import { CLONE_ASSURANCE_FROM } from "@/store/action.type"

export default {
  name: "DialogCloneAssuranceFrom",
  components: {
    FormSelectAssuranceInput,
  },
  props: {
    dialog: {
      required: true,
      type: Boolean,
    },
    assuranceLevel: {
      required: true,
      type: Number | String,
    },
  },
  computed: {
    ...mapGetters([
      "assuranceLevels",
      "years",
      "faculties",
      "majors",
      "vwTopicQuery",
      "cloneAssuranceFromLoading",
    ]),
  },
  data() {
    return {
      formData: {
        copy_evidence_file: false,
        from: {
          assuranceLevelId: "",
          yearId: "",
          facultyId: "",
          majorId: "",
        },
        to: {
          assuranceLevelId: "",
          yearId: "",
          facultyId: "",
          majorId: "",
        },
      },
      confirmMessage: {
        from: {
          assuranceLevel: "",
          year: "",
          faculty: "",
          major: "",
        },
        to: {
          assuranceLevel: "",
          year: "",
          faculty: "",
          major: "",
        },
      },
      submitLoading: false,
      showConfirmMessage: false,
      disabledConfirmBtn: true,
    }
  },
  methods: {
    closeDialog() {
      this.showConfirmMessage = false
      this.disabledConfirmBtn = false
      this.$emit("update:dialog", false)
    },
    filterAssuranceLevel(assuranceLevelId) {
      return this.assuranceLevels.filter(({ id }) => id === assuranceLevelId)[0]
    },
    filterYear(yearId) {
      return this.years.filter(({ id }) => id === yearId)[0]
    },
    filterFaculty(facultyId) {
      return (
        this.faculties.filter(({ id }) => id === facultyId)[0] || { name: "" }
      )
    },
    filterMajor(majorId) {
      return this.majors.filter(({ id }) => id === majorId)[0] || { name: "" }
    },
    async handleSubmit(formDataFrom) {
      this.formData.from = formDataFrom

      this.confirmMessage.to = {
        assuranceLevel: this.filterAssuranceLevel(
          this.vwTopicQuery.assuranceLevelId
        ).name,
        year: this.filterYear(this.vwTopicQuery.yearId).name,
        faculty: this.filterFaculty(this.vwTopicQuery.facultyId).name,
        major: this.filterMajor(this.vwTopicQuery.majorId).name,
      }

      this.confirmMessage.from = {
        assuranceLevel: this.filterAssuranceLevel(formDataFrom.assuranceLevelId)
          .name,
        year: this.filterYear(formDataFrom.yearId).name,
        faculty: this.filterFaculty(formDataFrom.facultyId).name,
        major: this.filterMajor(formDataFrom.majorId).name,
      }

      this.showConfirmMessage = true
      this.disabledConfirmBtn = false
    },
    async onConfirmClone() {
      this.formData.to = {
        assuranceLevelId: this.vwTopicQuery.assuranceLevelId,
        yearId: this.vwTopicQuery.yearId,
        facultyId: this.vwTopicQuery.facultyId,
        majorId: this.vwTopicQuery.majorId,
      }

      await this.$store.dispatch(CLONE_ASSURANCE_FROM, this.formData)

      const { assuranceLevelId, yearId, facultyId, majorId } = this.vwTopicQuery
      getAssurances(assuranceLevelId, yearId, facultyId, majorId)
    },
  },
}
</script>